import { render } from "./SideContainer.vue?vue&type=template&id=6aac3237"
import script from "./SideContainer.vue?vue&type=script&lang=js"
export * from "./SideContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__